import { Component, OnInit } from '@angular/core';
import { ToastrService } from "../../service/common/toastr.service";
import { TownHallsService } from "../../service/main/town-halls.service";
import { Router } from '@angular/router';


@Component({
  selector: 'app-add-townhall',
  templateUrl: './add-townhall.component.html',
  styleUrls: ['./add-townhall.component.css']
})
export class AddTownhallComponent implements OnInit {

  title: string;
  bankAccount: string;
  address: string;
  location: string;
  contactPhone: number;
  contactName: string;
  contactEmail: string;
  user: string;
  password: string;

  constructor(
    private toastr: ToastrService,
    private publicInstitution: TownHallsService,
    private router: Router,
  ) {
  }

  ngOnInit() {
  }

  addTownHalls() {
    const publicInstitution = {
      title: this.title,
      bankAccount: this.bankAccount,
      address: this.address,
      location: this.location,
      contactName: this.contactName,
      contactPhone: this.contactPhone,
      contactEmail: this.contactEmail,
      user: this.user,
      password: this.password,
    };
    this.publicInstitution.addPublicInstitution(publicInstitution).subscribe(data => {
      this.title = null;
      this.bankAccount = null;
      this.address = null;
      this.location = null;
      this.contactPhone = null;
      this.contactName = null;
      this.contactEmail = null;
      this.user = null;
      this.password = null;
      this.router.navigate(['town-halls-police']);
      this.toastr.success('Public institution added.');
    }, err => {
      this.toastr.error('An error occurred');
    });
  }
  cancel() {
    this.router.navigate(['town-halls-police']);
  }


}
